import { c as _c } from "react/compiler-runtime";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import type { CollectedCard } from "@/entities/IProfile";
import { CollectedCollectionType } from "@/entities/IProfile";
import { formatNumberWithCommasOrDash } from "@/helpers/Helpers";
import { ContractType } from "@/types/enums";
import { faCheck, faMinusCircle, faPlus, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import { useId, useState } from "react";
import { Tooltip } from "react-tooltip";
import { COLLECTED_COLLECTIONS_META } from "../filters/user-page-collected-filters.helpers";
export default function UserPageCollectedCard(t0) {
  const $ = _c(91);
  const {
    card,
    contractType,
    showDataRow,
    interactiveMode: t1,
    selected: t2,
    onToggle,
    onIncQty,
    onDecQty,
    copiesMax,
    qtySelected: t3,
    isTransferLoading: t4
  } = t0;
  const interactiveMode = t1 === undefined ? "link" : t1;
  const selected = t2 === undefined ? false : t2;
  const qtySelected = t3 === undefined ? 0 : t3;
  const isTransferLoading = t4 === undefined ? false : t4;
  const collectionMeta = COLLECTED_COLLECTIONS_META[card.collection];
  const path = `${collectionMeta.cardPath}/${card.token_id}`;
  const tooltipId = useId();
  const isSelectMode = interactiveMode === "select";
  const canSelect = copiesMax > 0;
  const isSelectModeAndCanSelect = isSelectMode && canSelect;
  const isSelectable = !selected && canSelect;
  const isNotSelectable = !selected && !canSelect;
  const isSelectedAndCanSelect = canSelect && selected;
  const hasBalanceMismatch = isSelectMode && copiesMax !== (card.seized_count ?? 0);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const showSeizedCount = COLLECTED_COLLECTIONS_META[card.collection].dataRows.seizedCount && !!card.seized_count;
  let t5;
  if ($[0] !== card.seized_count || $[1] !== copiesMax || $[2] !== isSelectMode) {
    t5 = () => {
      if (isSelectMode) {
        return formatNumberWithCommasOrDash(copiesMax);
      }
      return formatNumberWithCommasOrDash(card.seized_count ?? 0);
    };
    $[0] = card.seized_count;
    $[1] = copiesMax;
    $[2] = isSelectMode;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const getSeizedCountDisplay = t5;
  let t6;
  if ($[4] !== card.collection || $[5] !== card.tdh) {
    t6 = () => {
      if (card.collection === CollectedCollectionType.MEMELAB) {
        return "N/A";
      } else {
        return formatNumberWithCommasOrDash(+(card.tdh ?? 0).toFixed(0));
      }
    };
    $[4] = card.collection;
    $[5] = card.tdh;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const getTdhDisplay = t6;
  let t7;
  if ($[7] !== card.collection || $[8] !== card.rank || $[9] !== card.tdh) {
    t7 = () => {
      if (card.collection === CollectedCollectionType.MEMELAB) {
        return "N/A";
      } else {
        return card.tdh ? formatNumberWithCommasOrDash(card.rank ?? 0) : "-";
      }
    };
    $[7] = card.collection;
    $[8] = card.rank;
    $[9] = card.tdh;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const getRankDisplay = t7;
  let t8;
  if ($[11] !== contractType || $[12] !== copiesMax || $[13] !== isNotSelectable || $[14] !== isSelectMode || $[15] !== isSelectable || $[16] !== isSelectedAndCanSelect || $[17] !== isTransferLoading || $[18] !== onDecQty || $[19] !== onIncQty || $[20] !== onToggle || $[21] !== qtySelected) {
    t8 = isSelectMode ? <div className={["tw-pointer-events-none tw-absolute tw-inset-0 tw-z-10", "tw-flex tw-items-start tw-justify-end", "tw-p-2"].join(" ")}>{isNotSelectable && <div className="tw-pointer-events-auto tw-absolute tw-inset-0 tw-flex tw-items-start tw-justify-center tw-p-2"><div className="tw-rounded-md tw-bg-iron-900/95 tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-iron-300 tw-opacity-75 tw-ring-1 tw-ring-white/20 tw-transition-opacity tw-duration-200 group-hover:tw-opacity-100">{isTransferLoading ? <div className="tw-flex tw-items-center tw-gap-1"><span>Loading</span><CircleLoader size={CircleLoaderSize.SMALL} /></div> : "Not owned by your connected wallet"}</div></div>}{isSelectable && <button type="button" aria-label="Select" onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        onToggle();
      }} className={["tw-pointer-events-auto tw-flex tw-border-none", "tw-items-center tw-justify-center", "tw-h-9 tw-w-9 tw-rounded-full", "tw-bg-iron-900/90 hover:tw-bg-primary-500/75", "tw-ring-1 tw-ring-white/30"].join(" ")}><FontAwesomeIcon icon={faPlus} className="tw-size-5" color="#fff" /></button>}{isSelectedAndCanSelect && <div className="tw-pointer-events-auto tw-flex tw-items-center tw-gap-2">{contractType === ContractType.ERC1155 ? <div className={["tw-flex tw-items-center tw-justify-center tw-gap-1.5", "tw-rounded-full tw-bg-primary-500 tw-p-2 tw-backdrop-blur", "tw-mt-[2px] tw-font-medium"].join(" ")}><button type="button" onClick={e_0 => {
            e_0.preventDefault();
            e_0.stopPropagation();
            if (qtySelected <= 1) {
              onDecQty();
              onToggle();
            } else {
              onDecQty();
            }
          }} aria-label="Decrease quantity" className="tw-flex tw-items-center tw-border-none tw-bg-transparent tw-p-0 focus:tw-outline-none"><FontAwesomeIcon icon={faMinusCircle} className="tw-size-5" color="#fff" /></button><div className="tw-min-w-[2ch] tw-text-center tw-text-sm tw-tabular-nums tw-text-white">{qtySelected}/{copiesMax}</div><button type="button" onClick={e_1 => {
            e_1.preventDefault();
            e_1.stopPropagation();
            if (qtySelected < copiesMax) {
              onIncQty();
            }
          }} disabled={qtySelected >= copiesMax} aria-label="Increase quantity" className="tw-flex tw-items-center tw-border-none tw-bg-transparent tw-p-0 focus:tw-outline-none disabled:tw-opacity-50"><FontAwesomeIcon icon={faPlusCircle} className="tw-size-5" color="#fff" /></button></div> : <button type="button" aria-label="Deselect" onClick={e_2 => {
          e_2.preventDefault();
          e_2.stopPropagation();
          onToggle();
        }} className={["tw-flex tw-items-center tw-justify-center", "tw-h-9 tw-w-9 tw-rounded-full tw-bg-primary-500 hover:tw-bg-primary-600", "tw-ring-1 tw-ring-white/30"].join(" ")}><FontAwesomeIcon icon={faCheck} className="tw-size-5" /></button>}</div>}</div> : null;
    $[11] = contractType;
    $[12] = copiesMax;
    $[13] = isNotSelectable;
    $[14] = isSelectMode;
    $[15] = isSelectable;
    $[16] = isSelectedAndCanSelect;
    $[17] = isTransferLoading;
    $[18] = onDecQty;
    $[19] = onIncQty;
    $[20] = onToggle;
    $[21] = qtySelected;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const OverlayControls = t8;
  const isDisabled = isSelectMode && !canSelect;
  let t9;
  if ($[23] !== isDisabled || $[24] !== selected) {
    t9 = () => {
      if (selected) {
        return "tw-ring-2 tw-ring-primary-500 tw-ring-inset";
      }
      if (isDisabled) {
        return "tw-ring-1 tw-ring-inset tw-ring-iron-700 tw-opacity-60";
      }
      return "tw-ring-1 tw-ring-inset tw-ring-iron-700 hover:tw-ring-iron-600/60 hover:tw-to-white/10";
    };
    $[23] = isDisabled;
    $[24] = selected;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const getRingClasses = t9;
  let t10;
  if ($[26] !== isDisabled || $[27] !== isSelectModeAndCanSelect) {
    t10 = () => {
      if (isSelectModeAndCanSelect) {
        return "tw-cursor-pointer";
      }
      if (isDisabled) {
        return "tw-cursor-not-allowed";
      }
      return "";
    };
    $[26] = isDisabled;
    $[27] = isSelectModeAndCanSelect;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  const getCursorClasses = t10;
  let t11;
  if ($[29] !== isSelectModeAndCanSelect || $[30] !== onToggle || $[31] !== selected) {
    t11 = e_3 => {
      if (isSelectModeAndCanSelect && !selected) {
        e_3.preventDefault();
        onToggle();
      }
    };
    $[29] = isSelectModeAndCanSelect;
    $[30] = onToggle;
    $[31] = selected;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  const handleCardClick = t11;
  let t12;
  if ($[33] !== isSelectModeAndCanSelect || $[34] !== onToggle || $[35] !== selected) {
    t12 = e_4 => {
      if (isSelectModeAndCanSelect && !selected && (e_4.key === "Enter" || e_4.key === " ")) {
        e_4.preventDefault();
        onToggle();
      }
    };
    $[33] = isSelectModeAndCanSelect;
    $[34] = onToggle;
    $[35] = selected;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  const handleCardKeyDown = t12;
  let t13;
  if ($[37] !== handleCardClick || $[38] !== handleCardKeyDown || $[39] !== isSelectModeAndCanSelect || $[40] !== selected) {
    t13 = isSelectModeAndCanSelect && !selected ? {
      role: "button",
      tabIndex: 0,
      "aria-label": "Select NFT for transfer",
      onClick: handleCardClick,
      onKeyDown: handleCardKeyDown
    } : {};
    $[37] = handleCardClick;
    $[38] = handleCardKeyDown;
    $[39] = isSelectModeAndCanSelect;
    $[40] = selected;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  const t14 = getRingClasses();
  const t15 = getCursorClasses();
  let t16;
  if ($[42] !== t14 || $[43] !== t15) {
    t16 = ["tw-group tw-relative", "tw-flex tw-flex-col tw-overflow-hidden tw-rounded-lg tw-bg-gradient-to-br tw-from-iron-900 tw-to-white/5 tw-px-0.5 tw-pt-0.5 tw-transition tw-duration-300 tw-ease-out", t14, t15].filter(Boolean);
    $[42] = t14;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  const t17 = t16.join(" ");
  let t18;
  if ($[45] !== isImageLoaded) {
    t18 = !isImageLoaded && <div className="tw-absolute tw-inset-0 tw-animate-pulse tw-rounded-lg tw-bg-iron-800" />;
    $[45] = isImageLoaded;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setIsImageLoaded(true);
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  const t20 = `tw-mx-auto tw-h-auto tw-max-h-full tw-w-auto tw-max-w-full tw-bg-transparent tw-object-contain ${!isImageLoaded ? "tw-opacity-0" : "tw-opacity-100"} tw-transition-opacity tw-duration-300`;
  let t21;
  if ($[48] !== card.collection || $[49] !== card.img || $[50] !== t20) {
    t21 = <img src={card.img} alt={card.collection} onLoad={t19} className={t20} />;
    $[48] = card.collection;
    $[49] = card.img;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== t18 || $[53] !== t21) {
    t22 = <div className="tw-w-full tw-max-w-full"><div className="tw-relative tw-flex tw-h-[200px] tw-w-full tw-items-center tw-justify-center tw-text-center min-[800px]:tw-h-[250px] min-[1200px]:tw-h-[18.75rem]">{t18}{t21}</div></div>;
    $[52] = t18;
    $[53] = t21;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== collectionMeta.label) {
    t23 = <span className="tw-text-sm tw-font-medium tw-text-iron-400 min-[1200px]:tw-text-md">{collectionMeta.label}</span>;
    $[55] = collectionMeta.label;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== card.token_id) {
    t24 = <span className="tw-text-sm tw-font-medium tw-text-iron-500 min-[1200px]:tw-text-md">#{card.token_id}</span>;
    $[57] = card.token_id;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  if ($[59] !== t23 || $[60] !== t24) {
    t25 = <div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-px-2 tw-pt-3">{t23}{t24}</div>;
    $[59] = t23;
    $[60] = t24;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== t22 || $[63] !== t25) {
    t26 = <div className="tw-flex tw-flex-wrap">{t22}{t25}</div>;
    $[62] = t22;
    $[63] = t25;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] !== card.token_name) {
    t27 = <span className="tw-block tw-w-full tw-truncate tw-text-sm tw-font-medium tw-text-iron-50 min-[1200px]:tw-text-md">{card.token_name}</span>;
    $[65] = card.token_name;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  let t28;
  if ($[67] !== getSeizedCountDisplay || $[68] !== hasBalanceMismatch || $[69] !== showSeizedCount || $[70] !== tooltipId) {
    t28 = showSeizedCount && <span className="tw-flex tw-items-center tw-gap-0.5 tw-whitespace-nowrap tw-text-sm tw-font-medium tw-text-iron-400 min-[1200px]:tw-text-md">{getSeizedCountDisplay()}x{hasBalanceMismatch && <><span className="tw-cursor-help tw-text-primary-400" data-tooltip-id={tooltipId}>*</span><Tooltip id={tooltipId} variant="light" className="tw-z-[9999]" style={{
          padding: "6px 10px",
          fontSize: "12px",
          maxWidth: "85%",
          whiteSpace: "normal",
          wordWrap: "break-word"
        }}>Only the balance of the connected wallet is available for transfer</Tooltip></>}</span>;
    $[67] = getSeizedCountDisplay;
    $[68] = hasBalanceMismatch;
    $[69] = showSeizedCount;
    $[70] = tooltipId;
    $[71] = t28;
  } else {
    t28 = $[71];
  }
  let t29;
  if ($[72] !== t27 || $[73] !== t28) {
    t29 = <div className="tw-flex tw-justify-between tw-gap-x-2">{t27}{t28}</div>;
    $[72] = t27;
    $[73] = t28;
    $[74] = t29;
  } else {
    t29 = $[74];
  }
  let t30;
  if ($[75] !== getRankDisplay || $[76] !== getTdhDisplay || $[77] !== showDataRow) {
    t30 = showDataRow && <div className="tw-flex tw-items-center tw-justify-between tw-pt-2"><span className="tw-text-sm tw-font-medium min-[1200px]:tw-text-md"><span className="tw-text-iron-400">TDH</span><span className="tw-ml-1 tw-text-iron-50">{getTdhDisplay()}</span></span><span className="tw-text-sm tw-font-medium min-[1200px]:tw-text-md"><span className="tw-text-iron-400">Rank</span><span className="tw-ml-1 tw-text-iron-50">{getRankDisplay()}</span></span></div>;
    $[75] = getRankDisplay;
    $[76] = getTdhDisplay;
    $[77] = showDataRow;
    $[78] = t30;
  } else {
    t30 = $[78];
  }
  let t31;
  if ($[79] !== t29 || $[80] !== t30) {
    t31 = <div className="tw-h-full tw-w-full tw-self-end tw-px-2 tw-pb-4 tw-pt-2"><div className="tw-flex tw-h-full tw-flex-col tw-justify-between tw-gap-y-2.5 tw-divide-x-0 tw-divide-y tw-divide-solid tw-divide-iron-700">{t29}{t30}</div></div>;
    $[79] = t29;
    $[80] = t30;
    $[81] = t31;
  } else {
    t31 = $[81];
  }
  let t32;
  if ($[82] !== OverlayControls || $[83] !== t13 || $[84] !== t17 || $[85] !== t26 || $[86] !== t31) {
    t32 = <div {...t13} className={t17}>{OverlayControls}{t26}{t31}</div>;
    $[82] = OverlayControls;
    $[83] = t13;
    $[84] = t17;
    $[85] = t26;
    $[86] = t31;
    $[87] = t32;
  } else {
    t32 = $[87];
  }
  const CardBody = t32;
  if (isSelectMode) {
    return CardBody;
  }
  let t33;
  if ($[88] !== CardBody || $[89] !== path) {
    t33 = <Link href={path} className="tw-no-underline">{CardBody}</Link>;
    $[88] = CardBody;
    $[89] = path;
    $[90] = t33;
  } else {
    t33 = $[90];
  }
  return t33;
}